
// src/pages/About.js

import img1 from "../assets/illustrationPC.png";
import './../styles/styles.css';


function About() {
  return (
    <div style={{ maxWidth: '800px', margin: '2rem auto', padding: '0 1rem', lineHeight: '1.6', textAlign: 'justify' }}>
      <h1>À propos de Gioco Mortale</h1>

      <p>
        Gioco Mortale vous transporte dans des scènes de meurtres, où chaque personne est suspecte. A vous de déméler la vérité parmi les souvenirs de votre personnage.
      </p>

        <img
        src={img1}
        alt="Giovo Mortale"
        className="banner1"
        />
        
      <h2>Comment ça fonctionne ?</h2>
      <p>
        Il vous suffit de sélectionner le thème de votre soirée et de partager le conetnu avec les participants.
      </p>


    </div>
  );
}

export default About;
